import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

export interface WalletRepairResult {
  id: string;
  publicKey: string;
  balance: number;
  associatedTokenAccount: string | null;
  solBalanceBefore: number;
  solBalanceAfter: number;
  ataCreated: boolean;
  solFunded: boolean;
  actions: string[];
  message: string;
}

class WalletService {
  async repairWallet(walletId: string): Promise<WalletRepairResult> {
    const response = await axios.post(`${API_BASE_URL}/wallet/${walletId}/repair`);
    return response.data;
  }

  async repairWallets(walletIds: string[]): Promise<WalletRepairResult[]> {
    const uniqueIds = Array.from(new Set(walletIds.filter(Boolean)));
    return Promise.all(uniqueIds.map((id) => this.repairWallet(id)));
  }

  /** Repair from + to wallets involved in a failed transaction. */
  async repairTransactionWallets(
    fromWalletId?: string | null,
    toWalletId?: string | null
  ): Promise<WalletRepairResult[]> {
    return this.repairWallets([fromWalletId, toWalletId].filter(Boolean) as string[]);
  }

  summarizeRepairs(results: WalletRepairResult[]): string {
    if (results.length === 0) {
      return 'No wallets to repair.';
    }
    const changed = results.filter(
      (r) => r.ataCreated || r.solFunded || !r.actions.includes('no_action_needed')
    );
    if (changed.length === 0) {
      return 'All wallets are healthy; no changes were required.';
    }
    return changed.map((r) => `${r.publicKey.slice(0, 8)}…: ${r.message}`).join(' ');
  }
}

export const walletService = new WalletService();
